import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { IntegrationPedidoModalComponent } from './integration-pedido-modal.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        IntegrationPedidoModalComponent
    ],
    exports: [
        IntegrationPedidoModalComponent
    ]
})
export class IntegrationPedidoSharedModule { }
